
export const emartmall = {
    orders: {
      list: "/orders",
      ScanDeliverySuccess: "/scan-order-success",
      getFailedOrder: "/orders/get-failed-order",
    },
  };
  export default emartmall;
  